module.exports = __webpack_public_path__ + "static/media/lojaDeConveniencia.65bcc6f6.jpg";